export default function Logo({ className = "", light = true }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brox-logo">
      <svg width="30" height="30" viewBox="0 0 64 64" aria-hidden="true" className="shrink-0">
        <rect width="64" height="64" fill="#0D0E10" />
        <rect x="3.5" y="3.5" width="57" height="57" fill="none" stroke="#D96B27" strokeWidth="4" />
        <path
          d="M20 46V18h13a8.5 8.5 0 0 1 5.2 15.2L45 46h-8.4l-6-11H27v11H20zm7-17h5.6a2.9 2.9 0 0 0 0-5.8H27v5.8z"
          fill="#D96B27"
        />
        <rect x="49" y="12" width="6" height="6" fill="#F2EFE9" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className={`font-display text-2xl font-extrabold uppercase tracking-wide ${light ? "text-paper" : "text-ink-950"}`}>
          BROX
        </span>
        <span className="font-mono text-[9px] uppercase tracking-[0.42em] text-copper">Construct</span>
      </span>
    </span>
  );
}
